import { groupBy } from 'lodash';
import { upperCaseFirst } from '~/helpers/string';

export const DEFAULT_ATTRIBUTE_BRAND = 'PropFit';

type GroupableAttribute = {
  id: string;
  category?: string | null;
  name?: string;
};

export function groupByIntegration(
  integration: string | undefined,
  attributesList: GroupableAttribute[],
  brandName: string = DEFAULT_ATTRIBUTE_BRAND
) {
  return groupBy(attributesList, ({ id }) => {
    return integration && id.startsWith('integration_')
      ? `${
          integration.length > 3
            ? upperCaseFirst(integration)
            : integration.toUpperCase()
        }`
      : brandName;
  });
}
